import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from '@/i18n/langList.js'
Vue.use(VueI18n)

let lang = localStorage.getItem('language') || 'en'

console.log('lang',lang)

const i18n = new VueI18n({
  locale: lang,
  messages,
  silentTranslationWarn: true, //有疑慮
})
export default i18n